<script type="text/javascript">
  export default {
    props: ['type', 'pc', 'website', 'roles', 'static'],
    data() {
      return {
        editing: {},

        default_content: {
          type: 'site-navbar',
          light_logo: '',
          light_logo_alt: '',
          dark_logo: '',
          dark_logo_alt: '',
          left_nav: [
            {type: 'item', name: 'Sell', slug: '/selling', auth: 0, roles: []},
          ],
          account_menu: [
            {name: 'My profile', slug: '/my-profile', auth: 1, roles: []},
            {name: 'My listings', slug: '/my-listings', auth: 1, roles: []},
            {name: 'My favorites', slug: '/my-favorites', auth: 1, roles: []},
          ],
        },
      }
    },
    computed: {
      compRoles: function() {
        var results = [];
        for(var i in this.roles) {
          if(this.roles[i].title) { results.push({name: this.roles[i].title, value: this.roles[i].title}); }
        }
        return results;
      },
    },
    mounted() {
      if(this.type != 'editor') {
        window.addEventListener('resize', this.resizeNavbar);
        this.resizeNavbar();
      }
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.resizeNavbar);
    },
    created() {
      // console.log('static : ', this.static);
      if(this.pc && this.pc.init == 'Yes') { for(var i in this.default_content) { this.pc[i] = this.default_content[i]; } this.pc.init = ''; }
      if(this.type != 'editor') {
      if(this.static == 1) { $('body').addClass("static _m-t-60"); } else { $('body').removeClass("static _m-t-60"); }
      }
    },
    methods: {
      resizeNavbar() {
        if(document.getElementById("main_nav") && document.getElementById("sub_nav")){
          var tele = document.getElementById('main_nav');
          var rec = document.getElementById('sub_nav');
          const rChildren = rec.children;
          let numW = 0;
          let mores = 0;
          [...rChildren].forEach(item => { item.outHTML = ''; tele.appendChild(item); });
          const teleW = tele.offsetWidth;
          const tChildren = tele.children;
          [...tChildren].forEach(item => {
            numW += item.offsetWidth;
            if(numW > teleW && window.innerWidth > 992) { mores++; item.outHTML = ''; rec.appendChild(item); }
          });
          if(mores == 0) { document.getElementById('mores').style.display = 'none'; }
          else { document.getElementById( 'mores' ).style.display = 'block'; }
        }
      }
    }
  }
</script>

<template>
  <div>

    <div v-if="type == 'editor'">

      <b-modal ref="modal_edit_roles" centered size="lg" :title="'Edit roles'" :hide-footer="true">
        <div class="p-3">
          <div class="row">
            <div class="col-sm-6">
              <w-field SimpleDataType="String" v-model="editing.name" Title="Name :"></w-field>
            </div>
            <div class="col-sm-6">
              <w-field SimpleDataType="String" v-model="editing.slug" Title="Slug :"></w-field>
            </div>
            <div class="col-sm-6">
              <w-field SimpleDataType="String List, Single" v-model="editing.auth" Title="Require login : " :Options="[{name: 'Yes', value: 1}, {name: 'No', value: 0}]"></w-field>
            </div>
            <div class="col-sm-6">
              <w-field SimpleDataType="String List, Multi" v-model="editing.roles" Title="Require role(s) :" :Options="compRoles"></w-field>
            </div>
          </div>
        </div>
        <footer class="modal-footer modal-footer-custom">
          <button type="button" class="btn btn-light" @click="$refs.modal_edit_roles.hide()">Close</button>
        </footer>
      </b-modal>

      <h5 class="mt-5 mb-3 text-uppercase bg-gray-200 p-3"><Icon icon="ri:book-2-line"></Icon> Website navbar :</h5>
      <div class="row">
        <div class="col-sm-6">
          <w-field SimpleDataType="String" Title="Light logo :" v-model="pc.light_logo"></w-field>
        </div>
        <div class="col-sm-6">
          <w-field SimpleDataType="String" Title="Light logo alt text :" v-model="pc.light_logo_alt"></w-field>
        </div>
        <div class="col-sm-6">
          <w-field SimpleDataType="String" Title="Dark logo :" v-model="pc.dark_logo"></w-field>
        </div>
        <div class="col-sm-6">
          <w-field SimpleDataType="String" Title="Dark logo alt text :" v-model="pc.dark_logo_alt"></w-field>
        </div>
        <div class="col-sm-12">
          <div class="form-group">
            <label>Navbar menu</label>
            <draggable handle=".handle" v-bind="{animation: 200}" v-model="pc.left_nav">
              <transition-group tag="div">
                <div v-for="(menu, menu_i) in pc.left_nav" :key="'a'+menu_i">

                  <div v-if="menu.type =='item'" class="input-group mb-1">
                    <input type="text" class="form-control" placeholder="Item name..." v-model="menu.name">
                    <div class="input-group-append">
                      <input type="text" class="form-control" placeholder="Item slug..." v-model="menu.slug">
                      <button class="btn btn-white" type="button" v-tippy content="Edit roles" @click="editing = menu; $refs.modal_edit_roles.show()" :class="menu.auth || (menu.roles && menu.roles.length) ? 'text-danger' : ''"><Icon icon="ri:shield-user-line"></Icon></button>
                      <button class="btn btn-white" type="button" v-tippy content="Delete" @click="pc.left_nav.splice(menu_i, 1)"><Icon icon="ri:delete-bin-line"></Icon></button>
                      <button class="btn btn-white handle" type="button" v-tippy content="Drag to arrange"><Icon icon="ri:drag-move-2-fill"></Icon></button>
                    </div>
                  </div>

                  <div v-if="menu.type =='menu'">
                    <div class="input-group mb-1">
                      <input type="text" class="form-control" placeholder="Dropdown name..." v-model="menu.name">
                      <div class="input-group-append">
                        <button class="btn btn-white" type="button" v-tippy content="Edit roles" @click="editing = menu; $refs.modal_edit_roles.show()" :class="menu.auth || (menu.roles && menu.roles.length) ? 'text-danger' : ''"><Icon icon="ri:shield-user-line"></Icon></button>
                        <button class="btn btn-white" type="button" v-tippy content="Delete" @click="pc.left_nav.splice(menu_i, 1)"><Icon icon="ri:delete-bin-line"></Icon></button>
                        <button class="btn btn-white handle" type="button" v-tippy content="Drag to arrange"><Icon icon="ri:drag-move-2-fill"></Icon></button>
                      </div>
                    </div>

                    <div class="ml-4">
                      <draggable handle=".handle2" v-bind="{animation: 200}" v-model="menu.children">
                        <transition-group tag="div">
                          <div v-for="(child, child_i) in menu.children" :key="'a'+child_i" class="input-group mb-1">
                            <input type="text" class="form-control" placeholder="Item name..." v-model="child.name">
                            <div class="input-group-append">
                              <input type="text" class="form-control" placeholder="Item slug..." v-model="child.slug">
                              <button class="btn btn-white" type="button" v-tippy content="Edit roles" @click="editing = child; $refs.modal_edit_roles.show()" :class="child.auth || (child.roles && child.roles.length) ? 'text-danger' : ''"><Icon icon="ri:shield-user-line"></Icon></button>
                              <button class="btn btn-white" type="button" v-tippy content="Delete" @click="menu.children.splice(child_i, 1)"><Icon icon="ri:delete-bin-line"></Icon></button>
                              <button class="btn btn-white handle2" type="button" v-tippy content="Drag to arrange"><Icon icon="ri:drag-move-2-fill"></Icon></button>
                            </div>
                          </div>
                        </transition-group>
                      </draggable>
                      <button class="btn btn-sm btn-primary mb-1" type="button" @click="menu.children.push({type: 'item', name: '', slug: '', auth: 0, roles: []})"><Icon icon="ri:add-line" height="18"></Icon> Add dropdown item</button>
                    </div>
                  </div>
                </div>
              </transition-group>
            </draggable>
            <div class="my-2">
              <button class="btn btn-sm btn-primary mr-2" type="button" @click="pc.left_nav.push({type: 'item', name: '', slug: '', auth: 0, roles: []})"><Icon icon="ri:add-line" height="18"></Icon> Add item</button>
              <button class="btn btn-sm btn-primary" type="button" @click="pc.left_nav.push({type: 'menu', name: '', children: [], auth: 0, roles: []})"><Icon icon="ri:add-line" height="18"></Icon> Add dropdown</button>
            </div>
          </div>
        </div>
        <div class="col-sm-12">
          <div class="form-group">
            <label>My account menu</label>
            <draggable handle=".handle" v-bind="{animation: 200}" v-model="pc.account_menu">
              <transition-group tag="div">
                <div v-for="(menu, menu_i) in pc.account_menu" :key="'ac'+menu_i">
                  <div class="input-group mb-1">
                    <input type="text" class="form-control" placeholder="Item name..." v-model="menu.name">
                    <div class="input-group-append">
                      <input type="text" class="form-control" placeholder="Item slug..." v-model="menu.slug">
                      <button class="btn btn-white" type="button" v-tippy content="Edit roles" @click="editing = menu; $refs.modal_edit_roles.show()" :class="menu.auth || (menu.roles && menu.roles.length) ? 'text-danger' : ''"><Icon icon="ri:shield-user-line"></Icon></button>
                      <button class="btn btn-white" type="button" v-tippy content="Delete" @click="pc.account_menu.splice(menu_i, 1)"><Icon icon="ri:delete-bin-line"></Icon></button>
                      <button class="btn btn-white handle" type="button" v-tippy content="Drag to arrange"><Icon icon="ri:drag-move-2-fill"></Icon></button>
                    </div>
                  </div>
                </div>
              </transition-group>
            </draggable>
            <button class="btn btn-sm btn-primary" type="button" @click="pc.account_menu.push({name: '', slug: '', auth: 0, roles: []})"><Icon icon="ri:add-line" height="18"></Icon> Add item</button>
          </div>
        </div>
      </div>
    </div>

    <header v-else class="sticky">
      <nav class="navbar navbar-expand-lg fixed-top navbar-client text-nowrap" id="navbar">
        <div class="container-fluid">
          <a class="logo text-uppercase" href="/">
            

            <img :src="formatImage(website.site_navbar.light_logo)" :alt="website.site_navbar.light_logo_alt" class="logo-light" height="60" />
            <img :src="formatImage(website.site_navbar.dark_logo)" :alt="website.site_navbar.dark_logo_alt" class="logo-dark" height="60" />
          </a>
          <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation"><Icon icon="ri:menu-line" height="22"></Icon></button>
          <div class="collapse navbar-collapse" id="navbarCollapse">
            <ul class="navbar-nav ml-lg-5 navbar-center" id="main_nav">
              <li v-for="(item, item_i) in website.site_navbar.left_nav" :key="'a'+item_i" class="nav-item" v-if="(!item.auth || (item.auth && user.id)) && (!item.roles || !item.roles.length) || (user.id && item.roles && hasRole(item.roles))">
                <div v-if="item.type =='menu'" class="dropdown">
                  <a class="nav-link" href="" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{item.name}} <Icon icon="ri:arrow-down-s-line" height="15"></Icon></a>
                  <div class="dropdown-menu dropdown-menu-right">
                    <ul class="list-unstyled">
                      <li v-for="(child, child_i) in item.children" :key="'b'+child_i" class="nav-item" v-if="(!child.auth || (child.auth && user.id)) && (!child.roles || !child.roles.length) || (user.id && child.roles && hasRole(child.roles))"><a :href="child.slug" class="nav-link">{{child.name}}</a></li>
                    </ul>
                  </div>
                </div>
                <a v-else-if="item.type == 'item'" class="nav-link" :href="item.slug">{{item.name}}</a>
              </li>
            </ul>
            <ul class="navbar-nav mr-auto navbar-center" id="mores">
              <li class="nav-item">
                <div class="dropdown">
                  <a class="nav-link" href="" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">More <Icon icon="ri:arrow-down-s-line" height="15"></Icon></a>
                  <div class="dropdown-menu dropdown-menu-right">
                    <ul class="list-unstyled" id="sub_nav"></ul>
                  </div>
                </div>
              </li>
            </ul>
            <ul v-if="website.site_navbar.account_menu.length" class="navbar-nav ml-auto navbar-center">
              <li v-if="!user || (user && !user.id)" class="nav-item"><a class="nav-link" href="/login">Login</a></li>
              <li v-if="!user || (user && !user.id)" class="nav-item"><a class="nav-link" href="/register">Register</a></li>
              <li v-if="user && user.id" class="nav-item">
                <div class="dropdown">
                  <a class="nav-link" href="" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">My account <Icon icon="ri:arrow-down-s-line" height="15"></Icon></a>
                  <div class="dropdown-menu dropdown-menu-right">
                    <ul class="list-unstyled">
                      <li v-if="hasRole(['Dev','Admin','Admin Employee','Admin Social','Lead Admin','Lead User'])" class="nav-item"><a :href="app_admin_url" class="nav-link" target="_blank">Admin</a></li>
                      <li v-for="(menu, menu_i) in website.site_navbar.account_menu" :key="'ac'+menu_i" class="nav-item"><a :href="menu.slug" class="nav-link">{{menu.name}}</a></li>
                    </ul>
                  </div>
                </div>
              </li>
              <li v-if="user && user.id" class="nav-item">
                <a class="nav-link" href="/logout" onclick="event.preventDefault(); document.getElementById('logout-form').submit();">Logout</a>
                <form id="logout-form" action="/logout" method="POST" style="display: none;"></form>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>

  </div>
</template>
